<div class="app-header header-shadow">
    <div class="app-header__logo" style="width:190px">
        <a class="logo-src" [routerLink]="routerLinkVariable"></a>
        <div class="header__pane ml-auto">
            <div>
                <button type="button" class="hamburger close-sidebar-btn hamburger--elastic"  *ngIf="isMobileMenuOpen"
                    >
                    <span class="hamburger-box">
                        <span class="hamburger-inner">
                        </span>
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="app-header__mobile-menu">`
        <div>
            <button type="button" class="hamburger mobile-toggle-nav" (click)="toggleMobileMenu()">
                <span class="hamburger-box">
                    <span class="hamburger-inner"></span>
                </span>
            </button>
        </div>
    </div>
    <div class="app-header__menu">
        <span>
            <button type="button" class="btn-icon btn-icon-only btn btn-primary btn-sm mobile-toggle-header-nav">
                <span class="btn-icon-wrapper">
                    <i class="fa fa-ellipsis-v fa-w-6"></i>
                </span>
            </button>
        </span>
    </div>
    <div class="app-header__content" [class.mobile-visible]="isMobileMenuOpen">
        <div class="app-header-left">
            <ul class="header-megamenu nav">
                <li class="nav-item">
                    <a href="javascript:void(0);" (click)="redirectToPage('dash')" class="nav-link">
                        <i class="nav-link-icon pe-7s-graph"> </i> Dashboard
                    </a>
                </li>
                <li class="btn-group nav-item">
                    <a class="nav-link" (click)="toggleDropdown($event,'softManualsDropdown')"
                        [class.active]="isDropdownOpen['softManualsDropdown']">
                        <i class="nav-link-icon pe-7s-folder"> </i> Soft Manuals
                        <i class="fa fa-angle-down ml-2 opacity-5"></i>
                    </a>
                    <div *ngIf="softManualsDropdown" class="rm-pointers dropdown-menu show">
                        <div class="dropdown-menu-header">
                            <div class="dropdown-menu-header-inner bg-secondary">
                                <div class="menu-header-image opacity-5"
                                    style="background-image: url('assets/images/dropdown-header/abstract2.jpg');">
                                </div>
                                <div class="menu-header-content">
                                    <h5 class="menu-header-title">Projects</h5>
                                </div>
                            </div>
                        </div>
                        <div class="scroll-area-xs">
                            <div class="scrollbar-container">
                                <button *ngFor="let item of projectList" (click)="gotomanuals(item.id,item.project_no)" type="button"
                                    tabindex="0" class="dropdown-item">{{ item.project_no }}
                                </button>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="btn-group nav-item">
                    <a class="nav-link" (click)="toggleDropdown($event,'sparePartsDropdown')"
                        [class.active]="isDropdownOpen['sparePartsDropdown']">
                        <i class="nav-link-icon pe-7s-config"> </i> Spare Parts List
                        <i class="fa fa-angle-down ml-2 opacity-5"></i>
                    </a>
                    <div *ngIf="sparePartsDropdown" class="rm-pointers dropdown-menu show">
                        <div class="dropdown-menu-header">
                            <div class="dropdown-menu-header-inner bg-secondary">
                                <div class="menu-header-image opacity-5"
                                    style="background-image: url('assets/images/dropdown-header/abstract2.jpg');">
                                </div>
                                <div class="menu-header-content">
                                    <h5 class="menu-header-title">Projects</h5>
                                </div>
                            </div>
                        </div>
                        <div class="scroll-area-xs">
                            <div class="scrollbar-container">
                                <button *ngFor="let item of projectList" (click)="SparePartDetailsComponent(item.id,item.project_no)"
                                    type="button" tabindex="0" class="dropdown-item">{{ item.project_no }}
                                </button>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="nav-item">
                    <a href="javascript:void(0);" (click)="redirectToPage('ComplaintsList')" class="nav-link">
                        <i class="nav-link-icon pe-7s-call"> </i> Service Call / Complaint
                    </a>
                </li>
                <li class="nav-item">
                    <a href="javascript:void(0);" (click)="redirectToPage('help')" class="nav-link">
                        <i class="nav-link-icon pe-7s-help1"> </i> Help
                    </a>
                </li>
            </ul>
        </div>
        <div class="app-header-right">
            <div class="app-header-right" *ngIf="org_img && org_img.trim() !== ''">
                <img width="100px" height="50px" style="object-fit: contain" [src]="org_img">
            </div>              
            <div class="header-btn-lg pr-0">
                <div class="widget-content p-0">
                    <div class="widget-content-wrapper">
                        <div class="widget-content-left">
                            <div class="btn-group">
                                <!-- rajesh - old code 1 -->
                                <!-- <a data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="p-0 btn">
                                    <img width="42" class="rounded-circle"
                                        src="assets/images/avatars/anonymousfaceicon.jpg" alt="">
                                    <i class="fa fa-angle-down ml-2 opacity-8"></i>
                                </a> -->
                                <!-- rajesh - new code - right side logout was not working everytime -->
                                <a aria-haspopup="true" aria-expanded="false" class="p-0 btn" (click)="toggleDropdownprofile()"
                                    [class.show]="dropdownOpen">
                                    <img width="42" class="rounded-circle" src="assets/images/avatars/1.png" alt="">
                                    <i class="fa fa-angle-down ml-2 opacity-8"></i>
                                </a>
                                <div *ngIf="dropdownOpen"
                                    class="rm-pointers dropdown-menu-lg dropdown-menu dropdown-menu-right show">
                                    <!-- Dropdown content -->
                                    <div class="dropdown-menu-header">
                                        <div class="dropdown-menu-header-inner bg-info">
                                            <div class="menu-header-image opacity-2"
                                                style="background-image: url('assets/images/dropdown-header/city3.jpg');">
                                            </div>
                                            <div class="menu-header-content text-left">
                                                <div class="widget-content p-0">
                                                    <div class="widget-content-wrapper">
                                                        <div class="widget-content-left mr-3">
                                                            <img width="42" class="rounded-circle"
                                                                src="assets/images/avatars/1.png"
                                                                alt="">
                                                        </div>
                                                        <div class="widget-content-left">
                                                            <div class="widget-heading">{{name}}</div>
                                                            <div class="widget-subheading opacity-8">
                                                                <!-- A short profile  description -->
                                                            </div>
                                                        </div>
                                                        <div class="widget-content-right mr-2">
                                                            <button class="btn-pill btn-shadow btn-shine btn btn-focus"
                                                                (click)="logout()">Logout</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="scroll-area-xs" style="height: 150px;">
                                        <div class="scrollbar-container ps">
                                            <ul class="nav flex-column">
                                                <!-- <li class="nav-item-header nav-item">Activity</li> -->
                                                <li class="nav-item" *ngIf="userType === 'customer'">
                                                    <a (click)="profile()" class="nav-link">Profile
                                                        <!-- <div class="ml-auto badge badge-pill badge-info">8</div> -->
                                                    </a>
                                                </li>
                                                <!-- <li class="nav-item">
                                                    <a href="javascript:void(0);" class="nav-link">Chat
                                                        <div class="ml-auto badge badge-pill badge-info">8</div>
                                                    </a>
                                                </li> -->
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <!-- rajesh - old code 2 -->
                                <div style="display: none;" tabindex="-1" role="menu" aria-hidden="true"
                                    class="rm-pointers dropdown-menu-lg dropdown-menu dropdown-menu-right">
                                    <div class="dropdown-menu-header">
                                        <div class="dropdown-menu-header-inner bg-info">
                                            <div class="menu-header-image opacity-2"
                                                style="background-image: url('assets/images/dropdown-header/city3.jpg');">
                                            </div>
                                            <div class="menu-header-content text-left">
                                                <div class="widget-content p-0">
                                                    <div class="widget-content-wrapper">
                                                        <div class="widget-content-left mr-3">
                                                            <img width="42" class="rounded-circle"
                                                                src="/assets/images/avatars/1.png"
                                                                alt="">
                                                        </div>
                                                        <div class="widget-content-left">
                                                            <div class="widget-heading">{{name}}</div>
                                                            <div class="widget-subheading opacity-8">
                                                                <!-- A short profile  description -->
                                                            </div>
                                                        </div>
                                                        <div class="widget-content-right mr-2">
                                                            <button class="btn-pill btn-shadow btn-shine btn btn-focus"
                                                                (click)="logout()">Logout</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="widget-content-left  ml-3 header-user-info">
                            <div class="widget-heading"> {{name}} </div>
                            <div class="widget-subheading">
                                <!-- VP People Manager  -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="mobile-menu-modal" *ngIf="isMobileMenuOpen">
    <div class="mobile-modal-overlay" (click)="closeMobileMenu()"></div>
    <div class="mobile-modal-content mobile-modal-top">
      <button class="mobile-close-btn" (click)="closeMobileMenu()">&times;</button>
      <ul class="mobile-menu-list">
        <!-- Dashboard Link -->
        <li class="mobile-menu-item">
          <a href="javascript:void(0);" (click)="redirectToPage('dash')" class="mobile-menu-link">
            <i class="nav-link-icon pe-7s-graph"></i> Dashboard
          </a>
        </li>
        <!-- Soft Manuals Dropdown -->
        <li class="mobile-dropdown">
          <a 
            class="mobile-menu-link" 
            (click)="toggleDropdown($event, 'softManualsDropdown')" 
            [class.active]="isDropdownOpen['softManualsDropdown']">
            <i class="nav-link-icon pe-7s-folder"></i> Soft Manuals
            <i class="fa fa-angle-down ml-2 opacity-5"></i>
          </a>
          <div *ngIf="softManualsDropdown" class="mobile-dropdown-menu">
            <h5 class="mobile-dropdown-title">Projects</h5>
            <div class="mobile-dropdown-items">
              <button *ngFor="let item of projectList" 
                (click)="gotomanuals(item.id, item.project_no)" 
                class="mobile-dropdown-item">
                {{ item.project_no }}
              </button>
            </div>
          </div>
        </li>
        <!-- Spare Parts Dropdown -->
        <li class="mobile-dropdown">
          <a 
            class="mobile-menu-link" 
            (click)="toggleDropdown($event, 'sparePartsDropdown')" 
            [class.active]="isDropdownOpen['sparePartsDropdown']">
            <i class="nav-link-icon pe-7s-config"></i> Spare Parts List
            <i class="fa fa-angle-down ml-2 opacity-5"></i>
          </a>
          <div *ngIf="sparePartsDropdown" class="mobile-dropdown-menu">
            <h5 class="mobile-dropdown-title">Projects</h5>
            <div class="mobile-dropdown-items">
              <button *ngFor="let item of projectList" 
                (click)="SparePartDetailsComponent(item.id, item.project_no)" 
                class="mobile-dropdown-item">
                {{ item.project_no }}
              </button>
            </div>
          </div>
        </li>
        <!-- Service Call/Complaint Link -->
        <li class="mobile-menu-item">
          <a href="javascript:void(0);" (click)="redirectToPage('ComplaintsList')" class="mobile-menu-link">
            <i class="nav-link-icon pe-7s-call"></i> Service Call / Complaint
          </a>
        </li>
        <!-- Help Link -->
        <li class="mobile-menu-item">
          <a href="javascript:void(0);" (click)="redirectToPage('help')" class="mobile-menu-link">
            <i class="nav-link-icon pe-7s-help1"></i> Help
          </a>
        </li>
      </ul>
    </div>
  </div>
  
